import React from 'react';
import { useField, useFormikContext } from 'formik';

export default function DynamicForm({ campos }) {
  if (!campos) return <p>Carregando formulário...</p>;

  return (
    <div className="space-y-4">
      {campos.map((campo) => (
        <FieldRenderer key={campo.id} campo={campo} />
      ))}
    </div>
  );
}

function FieldRenderer({ campo }) {
  const [field, meta] = useField(campo.id);

  const baseClass = "w-full p-2 border rounded";
  const errorClass = meta.touched && meta.error ? "border-red-500" : "";

  switch (campo.tipo) {
    case 'texto':
      return (
        <div>
          <label className="block mb-1">{campo.label} {campo.obrigatorio && '*'}</label>
          <input type="text" {...field} placeholder={campo.placeholder} className={`${baseClass} ${errorClass}`} />
          {meta.touched && meta.error && <div className="text-red-500 text-sm">{meta.error}</div>}
        </div>
      );
    case 'numerico':
      return (
        <div>
          <label className="block mb-1">{campo.label} {campo.obrigatorio && '*'}</label>
          <input type="number" {...field} placeholder={campo.placeholder} className={`${baseClass} ${errorClass}`} />
        </div>
      );
    case 'selecao':
      return (
        <div>
          <label className="block mb-1">{campo.label} {campo.obrigatorio && '*'}</label>
          <select {...field} className={`${baseClass} ${errorClass}`}>
            <option value="">Selecione...</option>
            {campo.opcoes?.map((op) => <option key={op} value={op}>{op}</option>)}
          </select>
        </div>
      );
    case 'upload':
      return (
        <div>
          <label className="block mb-1">{campo.label} {campo.obrigatorio && '*'}</label>
          <input type="file" onChange={(e) => field.onChange({ target: { name: campo.id, value: e.target.files[0] } })} className={baseClass} />
        </div>
      );
    default:
      return null;
  }
}
